import { CurrencyAmount, Token, validateAndParseAddress } from '@sushiswap/sdk';
import { currencyToWei } from '../../../../../Fct/helpers';
import { toHex } from './toHex';
var ZERO_HEX = '0x0';
export var getV2SwapCallParamsFromTrade = function (trade, options) {
    var _a = trade.fromToken, chainId = _a.chainId, contractAddress = _a.contractAddress, decimals = _a.decimals;
    var currencyIn = new Token(chainId, contractAddress, decimals);
    var currencInAmount = CurrencyAmount.fromRawAmount(currencyIn, currencyToWei(trade.baseConvertRequest, decimals));
    var _b = trade.toToken, toTokenContractAddress = _b.contractAddress, toDecimals = _b.decimals;
    var currencyOut = new Token(chainId, toTokenContractAddress, toDecimals);
    var currencOutAmount = CurrencyAmount.fromRawAmount(currencyOut, currencyToWei(trade.minAmountConvertQuote, toDecimals));
    var to = validateAndParseAddress(options.recipient);
    var amountIn = toHex(currencInAmount);
    var amountOut = toHex(currencOutAmount);
    var path = trade.routePath;
    var paramsIn = {
        amountIn: amountIn,
        amountOutMin: amountOut,
        path: path,
        to: to,
    };
    return {
        params: paramsIn,
        value: ZERO_HEX,
    };
};
